export default [

     {
          path: '/classification-tags',
          name: 'ClassificationTag',
          component: () => import("@/views/Page/ClassificationTag/ClassificationTag.vue"),
           meta: {
               title: 'ClassificationTag',
          },
     }
];